import { AppThunk } from "config/commonTypes";
import {
  ManagedUser,
  UsersAction,
  UsersType,
  WelcomeEmailResponse,
} from "store/types/users";
import { routeToSpecificScope } from "../../helpers";
import {
  addLoadingFlag,
  changeMessageLoading,
  subLoadingFlag,
} from "./loading";
import { requestAsJson, requestData } from "../../config/services/datasets";
import { SERVER } from "../../config/server.config";

export const replaceUsers = (users: UsersType) => {
  return {
    type: UsersAction.REPLACE_USERS,
    users,
  };
};

export const createUser =
  (user: ManagedUser): AppThunk =>
  async (dispatch, getState) => {
    const scope = routeToSpecificScope(getState().router.location.pathname);
    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        userid: user.userid,
        firstName: user.firstName,
        lastName: user.lastName,
        roles: user.roles.map((role) => role._id),
      }),
    };
    dispatch(addLoadingFlag(scope));
    const response = await requestData(SERVER.CREATE_USER(), request);
    if (response) {
      dispatch(getUsers());
    }
    dispatch(subLoadingFlag(scope));
  };

export const updateUser =
  (user: ManagedUser): AppThunk =>
  async (dispatch, getState) => {
    const scope = routeToSpecificScope(getState().router.location.pathname);
    const request = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        userid: user.userid,
        firstName: user.firstName,
        lastName: user.lastName,
        roles: user.roles.map((role) => role._id),
      }),
    };
    dispatch(addLoadingFlag(scope));
    await requestData(SERVER.UPDATE_USER(user._id), request);
    dispatch(getUsers());
    dispatch(subLoadingFlag(scope));
  };

export const deleteUser =
  (userId: string): AppThunk =>
  async (dispatch, getState) => {
    const scope = routeToSpecificScope(getState().router.location.pathname);
    const request = {
      method: "DELETE",
      body: JSON.stringify({}),
    };
    dispatch(addLoadingFlag(scope));
    await requestData(SERVER.DELETE_USER(userId), request);
    dispatch(getUsers());
    dispatch(subLoadingFlag(scope));
  };

export const getUsers = (): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.GET_USERS());
    if (results && results.length) {
      dispatch(replaceUsers(results[0]));
    } else {
      dispatch(replaceUsers({}));
      dispatch(
        changeMessageLoading(scope, "No data matches your specified criteria")
      );
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const sendWelcomeEmail =
  (userId: string): AppThunk<Promise<WelcomeEmailResponse | string>> =>
  async () => {
    const request = {
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
      }),
    };
    return requestAsJson(SERVER.SEND_WELCOME_EMAIL(userId), request);
  };
